var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.248,
    height: 14.2,
    viewBox: "0 0 14.248 14.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#363636",
    stroke: "#363636",
    strokeWidth: "0.2px",
    d: "M29.794,16.205a.7.7,0,0,0-.99,0L23,22.01l-5.8-5.805a.7.7,0,0,0-.99.99L22.01,23l-5.8,5.805a.7.7,0,1,0,.99.99L23,23.99l5.8,5.805a.7.7,0,1,0,.99-.99L23.99,23l5.8-5.805A.7.7,0,0,0,29.794,16.205Z",
    transform: "translate(-15.852 -15.9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseReply);
export default __webpack_public_path__ + "static/media/close-reply.0fa260ce.svg";
export { ForwardRef as ReactComponent };